import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { SatelliteMachineCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";
import { InputSecret } from "../../../common/controls";
import { InputDateTime } from "../../../common/controls";
import { InputReference } from "../../../common/controls";
import { CreateEntityDialog } from "../../../common/controls";
import { UserCreate } from "../../../user/components/create/UserCreate";
import { UserCreateStore } from "../../../user/store";
import { InputBoolean } from "../../../common/controls";
import { InputNumber } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";

export type SatelliteMachineCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  name: string;
  nameError?: string;
  machineCodeSelectedValue?: { displayId: string; id: string } | null;
  onMachineCodeChange?: (value: string) => void;
  machineCode: string;
  machineCodeError?: string;
  satelliteTypeSelectedValue?: { displayId: string; id: string } | null;
  onSatelliteTypeChange?: (value: string) => void;
  satelliteType: string;
  satelliteTypeError?: string;
  regionSelectedValue?: { displayId: string; id: string } | null;
  onRegionChange?: (value: string) => void;
  region: string;
  regionError?: string;
  certificateFingerprintSelectedValue?: {
    displayId: string;
    id: string;
  } | null;
  onCertificateFingerprintChange?: (value: string) => void;
  certificateFingerprint: string;
  certificateFingerprintError?: string;
  certificateExpiresAtSelectedValue?: { displayId: string; id: string } | null;
  onCertificateExpiresAtChange?: (value: Date | null) => void;
  certificateExpiresAt: Date | null;
  certificateExpiresAtError?: string;
  authTokenHashSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenHashChange?: (value: string) => void;
  authTokenHash: string;
  authTokenHashError?: string;
  authTokenLastFourSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenLastFourChange?: (value: string) => void;
  authTokenLastFour: string;
  authTokenLastFourError?: string;
  authTokenCreatedAtSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenCreatedAtChange?: (value: Date | null) => void;
  authTokenCreatedAt: Date | null;
  authTokenCreatedAtError?: string;
  authTokenRotatedAtSelectedValue?: { displayId: string; id: string } | null;
  onAuthTokenRotatedAtChange?: (value: Date | null) => void;
  authTokenRotatedAt: Date | null;
  authTokenRotatedAtError?: string;
  statusSelectedValue?: { displayId: string; id: string } | null;
  onStatusChange?: (value: string) => void;
  status: string;
  statusError?: string;
  authorizedAtSelectedValue?: { displayId: string; id: string } | null;
  onAuthorizedAtChange?: (value: Date | null) => void;
  authorizedAt: Date | null;
  authorizedAtError?: string;
  authorizedBySelectedValue?: { displayId: string; id: string } | null;
  onAuthorizedBySelected?: (
    value: { displayId: string; id: string } | null
  ) => void;
  onAuthorizedByChange?: (value: string) => void;
  authorizedByOptions?: { displayId: string; id: string }[];
  authorizedByError?: string;
  suspendedAtSelectedValue?: { displayId: string; id: string } | null;
  onSuspendedAtChange?: (value: Date | null) => void;
  suspendedAt: Date | null;
  suspendedAtError?: string;
  suspendedBySelectedValue?: { displayId: string; id: string } | null;
  onSuspendedBySelected?: (
    value: { displayId: string; id: string } | null
  ) => void;
  onSuspendedByChange?: (value: string) => void;
  suspendedByOptions?: { displayId: string; id: string }[];
  suspendedByError?: string;
  suspensionReasonSelectedValue?: { displayId: string; id: string } | null;
  onSuspensionReasonChange?: (value: string) => void;
  suspensionReason: string;
  suspensionReasonError?: string;
  enabledSelectedValue?: { displayId: string; id: string } | null;
  onEnabledChange?: (value: boolean) => void;
  enabled: boolean;
  enabledError?: string;
  allowedTenantIdsSelectedValue?: { displayId: string; id: string } | null;
  onAllowedTenantIdsChange?: (value: string) => void;
  allowedTenantIds: string;
  allowedTenantIdsError?: string;
  proxyEnabledSelectedValue?: { displayId: string; id: string } | null;
  onProxyEnabledChange?: (value: boolean) => void;
  proxyEnabled: boolean;
  proxyEnabledError?: string;
  proxyPortSelectedValue?: { displayId: string; id: string } | null;
  onProxyPortChange?: (value: number | undefined) => void;
  proxyPort: number | undefined;
  proxyPortError?: string;
  proxyProtocolsSelectedValue?: { displayId: string; id: string } | null;
  onProxyProtocolsChange?: (value: string) => void;
  proxyProtocols: string;
  proxyProtocolsError?: string;
  botEnabledSelectedValue?: { displayId: string; id: string } | null;
  onBotEnabledChange?: (value: boolean) => void;
  botEnabled: boolean;
  botEnabledError?: string;
  botMaxConcurrentSelectedValue?: { displayId: string; id: string } | null;
  onBotMaxConcurrentChange?: (value: number | undefined) => void;
  botMaxConcurrent: number | undefined;
  botMaxConcurrentError?: string;
  workerEnabledSelectedValue?: { displayId: string; id: string } | null;
  onWorkerEnabledChange?: (value: boolean) => void;
  workerEnabled: boolean;
  workerEnabledError?: string;
  publicIpSelectedValue?: { displayId: string; id: string } | null;
  onPublicIpChange?: (value: string) => void;
  publicIp: string;
  publicIpError?: string;
  locationSelectedValue?: { displayId: string; id: string } | null;
  onLocationChange?: (value: string) => void;
  location: string;
  locationError?: string;
  countryCodeSelectedValue?: { displayId: string; id: string } | null;
  onCountryCodeChange?: (value: string) => void;
  countryCode: string;
  countryCodeError?: string;
  lastHeartbeatAtSelectedValue?: { displayId: string; id: string } | null;
  onLastHeartbeatAtChange?: (value: Date | null) => void;
  lastHeartbeatAt: Date | null;
  lastHeartbeatAtError?: string;
  lastHeartbeatMetricsSelectedValue?: { displayId: string; id: string } | null;
  onLastHeartbeatMetricsChange?: (value: string) => void;
  lastHeartbeatMetrics: string;
  lastHeartbeatMetricsError?: string;
  connectedAtSelectedValue?: { displayId: string; id: string } | null;
  onConnectedAtChange?: (value: Date | null) => void;
  connectedAt: Date | null;
  connectedAtError?: string;
  disconnectedAtSelectedValue?: { displayId: string; id: string } | null;
  onDisconnectedAtChange?: (value: Date | null) => void;
  disconnectedAt: Date | null;
  disconnectedAtError?: string;
  tunnelConnectedAtSelectedValue?: { displayId: string; id: string } | null;
  onTunnelConnectedAtChange?: (value: Date | null) => void;
  tunnelConnectedAt: Date | null;
  tunnelConnectedAtError?: string;
  satelliteMachineCreateStore: SatelliteMachineCreateStore;
};

export const SatelliteMachineCreateForm: React.FC<SatelliteMachineCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      name = "",
      nameError,
      onNameChange = () => {},
      machineCode = "",
      machineCodeError,
      onMachineCodeChange = () => {},
      satelliteType = "",
      satelliteTypeError,
      onSatelliteTypeChange = () => {},
      region = "",
      regionError,
      onRegionChange = () => {},
      certificateFingerprint = "",
      certificateFingerprintError,
      onCertificateFingerprintChange = () => {},
      certificateExpiresAt = null,
      certificateExpiresAtError,
      onCertificateExpiresAtChange = () => {},
      authTokenHash = "",
      authTokenHashError,
      onAuthTokenHashChange = () => {},
      authTokenLastFour = "",
      authTokenLastFourError,
      onAuthTokenLastFourChange = () => {},
      authTokenCreatedAt = null,
      authTokenCreatedAtError,
      onAuthTokenCreatedAtChange = () => {},
      authTokenRotatedAt = null,
      authTokenRotatedAtError,
      onAuthTokenRotatedAtChange = () => {},
      status = "",
      statusError,
      onStatusChange = () => {},
      authorizedAt = null,
      authorizedAtError,
      onAuthorizedAtChange = () => {},
      onAuthorizedBySelected = () => {},
      authorizedBySelectedValue = null,
      authorizedByOptions = [],
      authorizedByError,
      onAuthorizedByChange = () => {},
      suspendedAt = null,
      suspendedAtError,
      onSuspendedAtChange = () => {},
      onSuspendedBySelected = () => {},
      suspendedBySelectedValue = null,
      suspendedByOptions = [],
      suspendedByError,
      onSuspendedByChange = () => {},
      suspensionReason = "",
      suspensionReasonError,
      onSuspensionReasonChange = () => {},
      enabled = false,
      enabledError,
      onEnabledChange = () => {},
      allowedTenantIds = "",
      allowedTenantIdsError,
      onAllowedTenantIdsChange = () => {},
      proxyEnabled = false,
      proxyEnabledError,
      onProxyEnabledChange = () => {},
      proxyPort = undefined,
      proxyPortError,
      onProxyPortChange = () => {},
      proxyProtocols = "",
      proxyProtocolsError,
      onProxyProtocolsChange = () => {},
      botEnabled = false,
      botEnabledError,
      onBotEnabledChange = () => {},
      botMaxConcurrent = undefined,
      botMaxConcurrentError,
      onBotMaxConcurrentChange = () => {},
      workerEnabled = false,
      workerEnabledError,
      onWorkerEnabledChange = () => {},
      publicIp = "",
      publicIpError,
      onPublicIpChange = () => {},
      location = "",
      locationError,
      onLocationChange = () => {},
      countryCode = "",
      countryCodeError,
      onCountryCodeChange = () => {},
      lastHeartbeatAt = null,
      lastHeartbeatAtError,
      onLastHeartbeatAtChange = () => {},
      lastHeartbeatMetrics = "{}",
      lastHeartbeatMetricsError,
      onLastHeartbeatMetricsChange = () => {},
      connectedAt = null,
      connectedAtError,
      onConnectedAtChange = () => {},
      disconnectedAt = null,
      disconnectedAtError,
      onDisconnectedAtChange = () => {},
      tunnelConnectedAt = null,
      tunnelConnectedAtError,
      onTunnelConnectedAtChange = () => {},
      satelliteMachineCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="SatelliteMachine"
              mode="create"
              values={{}}
              options={{
                authorizedBy: authorizedByOptions,
                suspendedBy: suspendedByOptions,
              }}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "name":
                    onNameChange?.(valor);
                    break;
                  case "machineCode":
                    onMachineCodeChange?.(valor);
                    break;
                  case "satelliteType":
                    onSatelliteTypeChange?.(valor);
                    break;
                  case "region":
                    onRegionChange?.(valor);
                    break;
                  case "certificateFingerprint":
                    onCertificateFingerprintChange?.(valor);
                    break;
                  case "certificateExpiresAt":
                    onCertificateExpiresAtChange?.(valor);
                    break;
                  case "authTokenHash":
                    onAuthTokenHashChange?.(valor);
                    break;
                  case "authTokenLastFour":
                    onAuthTokenLastFourChange?.(valor);
                    break;
                  case "authTokenCreatedAt":
                    onAuthTokenCreatedAtChange?.(valor);
                    break;
                  case "authTokenRotatedAt":
                    onAuthTokenRotatedAtChange?.(valor);
                    break;
                  case "status":
                    onStatusChange?.(valor);
                    break;
                  case "authorizedAt":
                    onAuthorizedAtChange?.(valor);
                    break;
                  case "authorizedBy":
                    onAuthorizedBySelected?.(valor);
                    break;
                  case "suspendedAt":
                    onSuspendedAtChange?.(valor);
                    break;
                  case "suspendedBy":
                    onSuspendedBySelected?.(valor);
                    break;
                  case "suspensionReason":
                    onSuspensionReasonChange?.(valor);
                    break;
                  case "enabled":
                    onEnabledChange?.(valor);
                    break;
                  case "allowedTenantIds":
                    onAllowedTenantIdsChange?.(valor);
                    break;
                  case "proxyEnabled":
                    onProxyEnabledChange?.(valor);
                    break;
                  case "proxyPort":
                    onProxyPortChange?.(valor);
                    break;
                  case "proxyProtocols":
                    onProxyProtocolsChange?.(valor);
                    break;
                  case "botEnabled":
                    onBotEnabledChange?.(valor);
                    break;
                  case "botMaxConcurrent":
                    onBotMaxConcurrentChange?.(valor);
                    break;
                  case "workerEnabled":
                    onWorkerEnabledChange?.(valor);
                    break;
                  case "publicIp":
                    onPublicIpChange?.(valor);
                    break;
                  case "location":
                    onLocationChange?.(valor);
                    break;
                  case "countryCode":
                    onCountryCodeChange?.(valor);
                    break;
                  case "lastHeartbeatAt":
                    onLastHeartbeatAtChange?.(valor);
                    break;
                  case "lastHeartbeatMetrics":
                    onLastHeartbeatMetricsChange?.(valor);
                    break;
                  case "connectedAt":
                    onConnectedAtChange?.(valor);
                    break;
                  case "disconnectedAt":
                    onDisconnectedAtChange?.(valor);
                    break;
                  case "tunnelConnectedAt":
                    onTunnelConnectedAtChange?.(valor);
                    break;
                }
              }}
            />

            <GroupContainer
              id="identity"
              errorText={satelliteMachineCreateStore.getCardErrors("identity")}
              title={langStore.groupSatelliteMachineIdentityLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState("identity")}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("identity")
              }
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={name}
                  error={Boolean(nameError)}
                  warning={
                    !nameError &&
                    Boolean(satelliteMachineCreateStore.warnings["name"])
                  }
                  helperText={
                    nameError ||
                    satelliteMachineCreateStore.warnings["name"]?.message
                  }
                  label={langStore.SatelliteMachineNameLabel}
                  onChange={(value: string) => onNameChange(value)}
                  description={langStore.SatelliteMachineNameDescription}
                />

                <InputString
                  value={machineCode}
                  error={Boolean(machineCodeError)}
                  warning={
                    !machineCodeError &&
                    Boolean(satelliteMachineCreateStore.warnings["machineCode"])
                  }
                  helperText={
                    machineCodeError ||
                    satelliteMachineCreateStore.warnings["machineCode"]?.message
                  }
                  label={langStore.SatelliteMachineMachineCodeLabel}
                  onChange={(value: string) => onMachineCodeChange(value)}
                  description={langStore.SatelliteMachineMachineCodeDescription}
                />

                <InputString
                  value={satelliteType}
                  error={Boolean(satelliteTypeError)}
                  warning={
                    !satelliteTypeError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["satelliteType"]
                    )
                  }
                  helperText={
                    satelliteTypeError ||
                    satelliteMachineCreateStore.warnings["satelliteType"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineSatelliteTypeLabel}
                  onChange={(value: string) => onSatelliteTypeChange(value)}
                  description={
                    langStore.SatelliteMachineSatelliteTypeDescription
                  }
                />

                <InputString
                  value={region}
                  error={Boolean(regionError)}
                  warning={
                    !regionError &&
                    Boolean(satelliteMachineCreateStore.warnings["region"])
                  }
                  helperText={
                    regionError ||
                    satelliteMachineCreateStore.warnings["region"]?.message
                  }
                  label={langStore.SatelliteMachineRegionLabel}
                  onChange={(value: string) => onRegionChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineRegionDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="certificate"
              errorText={satelliteMachineCreateStore.getCardErrors(
                "certificate"
              )}
              title={langStore.groupSatelliteMachineCertificateLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState("certificate")}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("certificate")
              }
            >
              <FormControl fullWidth>
                <InputSecret
                  value={certificateFingerprint}
                  error={Boolean(certificateFingerprintError)}
                  helperText={
                    certificateFingerprintError ||
                    satelliteMachineCreateStore.warnings[
                      "certificateFingerprint"
                    ]?.message
                  }
                  label={langStore.SatelliteMachineCertificateFingerprintLabel}
                  onChange={(value: string) =>
                    onCertificateFingerprintChange(value)
                  }
                  description={
                    langStore.SatelliteMachineCertificateFingerprintDescription
                  }
                />
                <InputDateTime
                  value={certificateExpiresAt}
                  error={Boolean(certificateExpiresAtError)}
                  warning={
                    !certificateExpiresAtError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings[
                        "certificateExpiresAt"
                      ]
                    )
                  }
                  helperText={
                    certificateExpiresAtError ||
                    satelliteMachineCreateStore.warnings["certificateExpiresAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineCertificateExpiresAtLabel}
                  description={
                    langStore.SatelliteMachineCertificateExpiresAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onCertificateExpiresAtChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="authentication"
              errorText={satelliteMachineCreateStore.getCardErrors(
                "authentication"
              )}
              title={langStore.groupSatelliteMachineAuthenticationLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState(
                "authentication"
              )}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("authentication")
              }
            >
              <FormControl fullWidth>
                <InputSecret
                  value={authTokenHash}
                  error={Boolean(authTokenHashError)}
                  helperText={
                    authTokenHashError ||
                    satelliteMachineCreateStore.warnings["authTokenHash"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenHashLabel}
                  onChange={(value: string) => onAuthTokenHashChange(value)}
                  description={
                    langStore.SatelliteMachineAuthTokenHashDescription
                  }
                />

                <InputString
                  value={authTokenLastFour}
                  error={Boolean(authTokenLastFourError)}
                  warning={
                    !authTokenLastFourError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["authTokenLastFour"]
                    )
                  }
                  helperText={
                    authTokenLastFourError ||
                    satelliteMachineCreateStore.warnings["authTokenLastFour"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenLastFourLabel}
                  onChange={(value: string) => onAuthTokenLastFourChange(value)}
                  description={
                    langStore.SatelliteMachineAuthTokenLastFourDescription
                  }
                />
                <InputDateTime
                  value={authTokenCreatedAt}
                  error={Boolean(authTokenCreatedAtError)}
                  warning={
                    !authTokenCreatedAtError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["authTokenCreatedAt"]
                    )
                  }
                  helperText={
                    authTokenCreatedAtError ||
                    satelliteMachineCreateStore.warnings["authTokenCreatedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenCreatedAtLabel}
                  description={
                    langStore.SatelliteMachineAuthTokenCreatedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onAuthTokenCreatedAtChange(value)
                  }
                />
                <InputDateTime
                  value={authTokenRotatedAt}
                  error={Boolean(authTokenRotatedAtError)}
                  warning={
                    !authTokenRotatedAtError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["authTokenRotatedAt"]
                    )
                  }
                  helperText={
                    authTokenRotatedAtError ||
                    satelliteMachineCreateStore.warnings["authTokenRotatedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthTokenRotatedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineAuthTokenRotatedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onAuthTokenRotatedAtChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="authorization"
              errorText={satelliteMachineCreateStore.getCardErrors(
                "authorization"
              )}
              title={langStore.groupSatelliteMachineAuthorizationLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState(
                "authorization"
              )}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("authorization")
              }
            >
              <FormControl fullWidth>
                <InputString
                  value={status}
                  error={Boolean(statusError)}
                  warning={
                    !statusError &&
                    Boolean(satelliteMachineCreateStore.warnings["status"])
                  }
                  helperText={
                    statusError ||
                    satelliteMachineCreateStore.warnings["status"]?.message
                  }
                  label={langStore.SatelliteMachineStatusLabel}
                  onChange={(value: string) => onStatusChange(value)}
                  description={langStore.SatelliteMachineStatusDescription}
                />
                <InputDateTime
                  value={authorizedAt}
                  error={Boolean(authorizedAtError)}
                  warning={
                    !authorizedAtError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["authorizedAt"]
                    )
                  }
                  helperText={
                    authorizedAtError ||
                    satelliteMachineCreateStore.warnings["authorizedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAuthorizedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineAuthorizedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onAuthorizedAtChange(value)
                  }
                />
                <InputReference
                  id="authorizedBy"
                  label={langStore.SatelliteMachineAuthorizedByLabel}
                  error={Boolean(authorizedByError)}
                  helperText={
                    authorizedByError ||
                    satelliteMachineCreateStore.warnings["authorizedBy"]
                      ?.message
                  }
                  selectedValue={authorizedBySelectedValue}
                  onChange={(value: string) => onAuthorizedByChange(value)}
                  onSelect={(value: { displayId: string; id: string } | null) =>
                    onAuthorizedBySelected(value)
                  }
                  options={authorizedByOptions}
                  description={
                    langStore.SatelliteMachineAuthorizedByDescription
                  }
                  nullText={langStore.optionalFieldHint}
                  canCreate={rootStore.authStore.hasPermissions("user_create")}
                  renderCreateDialog={(dialogProps) => (
                    <CreateEntityDialog
                      {...dialogProps}
                      createStore={(rootStore) =>
                        new UserCreateStore(rootStore)
                      }
                      renderForm={(store) => (
                        <UserCreate
                          userCreateStore={store}
                          showToolbox={false}
                          showSaveFooter={false}
                        />
                      )}
                      saveMethod="saveNewUser"
                      cancelMethod="cancelNewUser"
                    />
                  )}
                />
                <InputDateTime
                  value={suspendedAt}
                  error={Boolean(suspendedAtError)}
                  warning={
                    !suspendedAtError &&
                    Boolean(satelliteMachineCreateStore.warnings["suspendedAt"])
                  }
                  helperText={
                    suspendedAtError ||
                    satelliteMachineCreateStore.warnings["suspendedAt"]?.message
                  }
                  label={langStore.SatelliteMachineSuspendedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineSuspendedAtDescription}
                  onChange={(value: Date | null | null) =>
                    onSuspendedAtChange(value)
                  }
                />
                <InputReference
                  id="suspendedBy"
                  label={langStore.SatelliteMachineSuspendedByLabel}
                  error={Boolean(suspendedByError)}
                  helperText={
                    suspendedByError ||
                    satelliteMachineCreateStore.warnings["suspendedBy"]?.message
                  }
                  selectedValue={suspendedBySelectedValue}
                  onChange={(value: string) => onSuspendedByChange(value)}
                  onSelect={(value: { displayId: string; id: string } | null) =>
                    onSuspendedBySelected(value)
                  }
                  options={suspendedByOptions}
                  description={langStore.SatelliteMachineSuspendedByDescription}
                  nullText={langStore.optionalFieldHint}
                  canCreate={rootStore.authStore.hasPermissions("user_create")}
                  renderCreateDialog={(dialogProps) => (
                    <CreateEntityDialog
                      {...dialogProps}
                      createStore={(rootStore) =>
                        new UserCreateStore(rootStore)
                      }
                      renderForm={(store) => (
                        <UserCreate
                          userCreateStore={store}
                          showToolbox={false}
                          showSaveFooter={false}
                        />
                      )}
                      saveMethod="saveNewUser"
                      cancelMethod="cancelNewUser"
                    />
                  )}
                />

                <InputString
                  value={suspensionReason}
                  error={Boolean(suspensionReasonError)}
                  warning={
                    !suspensionReasonError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["suspensionReason"]
                    )
                  }
                  helperText={
                    suspensionReasonError ||
                    satelliteMachineCreateStore.warnings["suspensionReason"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineSuspensionReasonLabel}
                  onChange={(value: string) => onSuspensionReasonChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineSuspensionReasonDescription
                  }
                />
                <InputBoolean
                  value={enabled}
                  error={Boolean(enabledError)}
                  helperText={
                    enabledError ||
                    satelliteMachineCreateStore.warnings["enabled"]?.message
                  }
                  label={langStore.SatelliteMachineEnabledLabel}
                  description={langStore.SatelliteMachineEnabledDescription}
                  onChange={(value: boolean) => onEnabledChange(value)}
                />

                <InputString
                  value={allowedTenantIds}
                  error={Boolean(allowedTenantIdsError)}
                  warning={
                    !allowedTenantIdsError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["allowedTenantIds"]
                    )
                  }
                  helperText={
                    allowedTenantIdsError ||
                    satelliteMachineCreateStore.warnings["allowedTenantIds"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineAllowedTenantIdsLabel}
                  onChange={(value: string) => onAllowedTenantIdsChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineAllowedTenantIdsDescription
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="capabilities"
              errorText={satelliteMachineCreateStore.getCardErrors(
                "capabilities"
              )}
              title={langStore.groupSatelliteMachineCapabilitiesLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState(
                "capabilities"
              )}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("capabilities")
              }
            >
              <FormControl fullWidth>
                <InputBoolean
                  value={proxyEnabled}
                  error={Boolean(proxyEnabledError)}
                  helperText={
                    proxyEnabledError ||
                    satelliteMachineCreateStore.warnings["proxyEnabled"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineProxyEnabledLabel}
                  description={
                    langStore.SatelliteMachineProxyEnabledDescription
                  }
                  onChange={(value: boolean) => onProxyEnabledChange(value)}
                />
                <InputNumber
                  value={proxyPort}
                  nullable={true}
                  error={Boolean(proxyPortError)}
                  warning={
                    !proxyPortError &&
                    Boolean(satelliteMachineCreateStore.warnings["proxyPort"])
                  }
                  helperText={
                    proxyPortError ||
                    satelliteMachineCreateStore.warnings["proxyPort"]?.message
                  }
                  allowNegative={false}
                  label={langStore.SatelliteMachineProxyPortLabel}
                  decimalScale={0}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineProxyPortDescription}
                  onChange={(value: number | undefined) =>
                    onProxyPortChange(value)
                  }
                />

                <InputString
                  value={proxyProtocols}
                  error={Boolean(proxyProtocolsError)}
                  warning={
                    !proxyProtocolsError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["proxyProtocols"]
                    )
                  }
                  helperText={
                    proxyProtocolsError ||
                    satelliteMachineCreateStore.warnings["proxyProtocols"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineProxyProtocolsLabel}
                  onChange={(value: string) => onProxyProtocolsChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineProxyProtocolsDescription
                  }
                />
                <InputBoolean
                  value={botEnabled}
                  error={Boolean(botEnabledError)}
                  helperText={
                    botEnabledError ||
                    satelliteMachineCreateStore.warnings["botEnabled"]?.message
                  }
                  label={langStore.SatelliteMachineBotEnabledLabel}
                  description={langStore.SatelliteMachineBotEnabledDescription}
                  onChange={(value: boolean) => onBotEnabledChange(value)}
                />
                <InputNumber
                  value={botMaxConcurrent}
                  nullable={true}
                  error={Boolean(botMaxConcurrentError)}
                  warning={
                    !botMaxConcurrentError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["botMaxConcurrent"]
                    )
                  }
                  helperText={
                    botMaxConcurrentError ||
                    satelliteMachineCreateStore.warnings["botMaxConcurrent"]
                      ?.message
                  }
                  allowNegative={false}
                  label={langStore.SatelliteMachineBotMaxConcurrentLabel}
                  decimalScale={0}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineBotMaxConcurrentDescription
                  }
                  onChange={(value: number | undefined) =>
                    onBotMaxConcurrentChange(value)
                  }
                />
                <InputBoolean
                  value={workerEnabled}
                  error={Boolean(workerEnabledError)}
                  helperText={
                    workerEnabledError ||
                    satelliteMachineCreateStore.warnings["workerEnabled"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineWorkerEnabledLabel}
                  description={
                    langStore.SatelliteMachineWorkerEnabledDescription
                  }
                  onChange={(value: boolean) => onWorkerEnabledChange(value)}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="network"
              errorText={satelliteMachineCreateStore.getCardErrors("network")}
              title={langStore.groupSatelliteMachineNetworkLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState("network")}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("network")
              }
            >
              <FormControl fullWidth>
                <InputString
                  value={publicIp}
                  error={Boolean(publicIpError)}
                  warning={
                    !publicIpError &&
                    Boolean(satelliteMachineCreateStore.warnings["publicIp"])
                  }
                  helperText={
                    publicIpError ||
                    satelliteMachineCreateStore.warnings["publicIp"]?.message
                  }
                  label={langStore.SatelliteMachinePublicIpLabel}
                  onChange={(value: string) => onPublicIpChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachinePublicIpDescription}
                />

                <InputString
                  value={location}
                  error={Boolean(locationError)}
                  warning={
                    !locationError &&
                    Boolean(satelliteMachineCreateStore.warnings["location"])
                  }
                  helperText={
                    locationError ||
                    satelliteMachineCreateStore.warnings["location"]?.message
                  }
                  label={langStore.SatelliteMachineLocationLabel}
                  onChange={(value: string) => onLocationChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineLocationDescription}
                />

                <InputString
                  value={countryCode}
                  error={Boolean(countryCodeError)}
                  warning={
                    !countryCodeError &&
                    Boolean(satelliteMachineCreateStore.warnings["countryCode"])
                  }
                  helperText={
                    countryCodeError ||
                    satelliteMachineCreateStore.warnings["countryCode"]?.message
                  }
                  label={langStore.SatelliteMachineCountryCodeLabel}
                  onChange={(value: string) => onCountryCodeChange(value)}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineCountryCodeDescription}
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="monitoring"
              errorText={satelliteMachineCreateStore.getCardErrors(
                "monitoring"
              )}
              title={langStore.groupSatelliteMachineMonitoringLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState("monitoring")}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("monitoring")
              }
            >
              <FormControl fullWidth>
                <InputDateTime
                  value={lastHeartbeatAt}
                  error={Boolean(lastHeartbeatAtError)}
                  warning={
                    !lastHeartbeatAtError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["lastHeartbeatAt"]
                    )
                  }
                  helperText={
                    lastHeartbeatAtError ||
                    satelliteMachineCreateStore.warnings["lastHeartbeatAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineLastHeartbeatAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineLastHeartbeatAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onLastHeartbeatAtChange(value)
                  }
                />

                <InputCodeEditor
                  value={lastHeartbeatMetrics}
                  error={Boolean(lastHeartbeatMetricsError)}
                  helperText={
                    lastHeartbeatMetricsError ||
                    satelliteMachineCreateStore.warnings["lastHeartbeatMetrics"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineLastHeartbeatMetricsLabel}
                  onChange={(value: string) =>
                    onLastHeartbeatMetricsChange(value)
                  }
                  language="json"
                  description={
                    langStore.SatelliteMachineLastHeartbeatMetricsDescription
                  }
                />
                <InputDateTime
                  value={connectedAt}
                  error={Boolean(connectedAtError)}
                  warning={
                    !connectedAtError &&
                    Boolean(satelliteMachineCreateStore.warnings["connectedAt"])
                  }
                  helperText={
                    connectedAtError ||
                    satelliteMachineCreateStore.warnings["connectedAt"]?.message
                  }
                  label={langStore.SatelliteMachineConnectedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={langStore.SatelliteMachineConnectedAtDescription}
                  onChange={(value: Date | null | null) =>
                    onConnectedAtChange(value)
                  }
                />
                <InputDateTime
                  value={disconnectedAt}
                  error={Boolean(disconnectedAtError)}
                  warning={
                    !disconnectedAtError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["disconnectedAt"]
                    )
                  }
                  helperText={
                    disconnectedAtError ||
                    satelliteMachineCreateStore.warnings["disconnectedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineDisconnectedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineDisconnectedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onDisconnectedAtChange(value)
                  }
                />
                <InputDateTime
                  value={tunnelConnectedAt}
                  error={Boolean(tunnelConnectedAtError)}
                  warning={
                    !tunnelConnectedAtError &&
                    Boolean(
                      satelliteMachineCreateStore.warnings["tunnelConnectedAt"]
                    )
                  }
                  helperText={
                    tunnelConnectedAtError ||
                    satelliteMachineCreateStore.warnings["tunnelConnectedAt"]
                      ?.message
                  }
                  label={langStore.SatelliteMachineTunnelConnectedAtLabel}
                  nullText={langStore.optionalFieldHint}
                  description={
                    langStore.SatelliteMachineTunnelConnectedAtDescription
                  }
                  onChange={(value: Date | null | null) =>
                    onTunnelConnectedAtChange(value)
                  }
                />
              </FormControl>
            </GroupContainer>

            <GroupContainer
              id="relations"
              errorText={satelliteMachineCreateStore.getCardErrors("relations")}
              title={langStore.groupSatelliteMachineRelationsLabel}
              collapsible={true}
              expanded={satelliteMachineCreateStore.getCardState("relations")}
              toggleExpand={() =>
                satelliteMachineCreateStore.toggleCardState("relations")
              }
            >
              <FormControl fullWidth></FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
